import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { UsersEdit as Presenter, UsersEditStateProps, UsersEditOwnProps } from "./presenter";
import { GlobalState } from "@app/models/state";
import { makeGetUser } from "@auth/selectors";
import { compose } from "@util/compose";

// Map the users state to the component.
const makeMapStateToProps = () => {
    const getUser = makeGetUser();
    return (state: GlobalState, ownProps: UsersEditOwnProps) => {
        return {
            user: getUser(state, ownProps),
        } as UsersEditStateProps;
    };
};

export const UsersEdit = compose<UsersEditStateProps, UsersEditOwnProps>(
    connect(makeMapStateToProps, null),
    withRouter,
)(Presenter);
